import { useTranslation } from 'react-i18next'

import {
  Button,
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'

import { IErrorStateProps } from '../types'

export const ErrorState = ({ onRetry }: IErrorStateProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <div className="flex flex-col gap-2">
        <Typography
          variant={TypographyVariant.bodyXl}
          weight={TypographyWeight.medium}
          className="text-content-primary"
        >
          {t('whyWeInvest.error.title')}
        </Typography>
        <Typography
          variant={TypographyVariant.bodyMd}
          className="text-content-secondary"
        >
          {t('whyWeInvest.error.message')}
        </Typography>
      </div>
      <Button label={t('whyWeInvest.error.retry')} onClick={onRetry} />
    </div>
  )
}
